import type { CategoricalBarChartState } from '../../types/state.js';

export const setMouseOutBounds = (prev: CategoricalBarChartState) => ({
  ...prev,
  overlays: {
    ...prev.overlays,
    mouseInBounds: false,
    mousePosition: undefined,
    visibleTooltip: prev.overlays.pinnedTooltip,
  },
});
